import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { UpdateJobMutation } from "graphql.generated";

import { ActionSource } from "../../state/action-sources";

export const JobHeaderActions = createActionGroup({
  source: ActionSource.JOB_HEADER,
  events: {
    'Download Latest Invoice Menu Item Clicked': emptyProps(),
    'Open Job Menu Item Clicked': emptyProps(),
    'Close Job Menu Item Clicked': emptyProps(),
    'View Job History Menu Item Clicked': emptyProps(),
    'Send Document Menu Item Clicked': emptyProps(),
    'Change Area Menu Item Clicked': emptyProps(),
    'Use Calculator From Zone Settings Menu Item Clicked': emptyProps(),
    'Delete Job Menu Item Clicked': emptyProps(),
    'Job Code Clicked': emptyProps(),
    'Save Button Clicked': emptyProps(),
    'Save Job Footer Clicked': emptyProps(),
    'Open Job Success': props<{ updatedJob: UpdateJobMutation['updateJobs']['jobs'][0] }>(),
    'Open Job Error': props<{ error: Error }>(),
  },
})
